import React from "react";
import { IDynamicFees } from "views/admin/dynamicFees/types/fees.interface";

interface IFeesCtx {
  fees: IDynamicFees[];
  setFees: React.Dispatch<React.SetStateAction<IDynamicFees[]>>;
}

const FeesContext = React.createContext<IFeesCtx>({} as IFeesCtx);

export default FeesContext;
